module.exports = __webpack_public_path__ + "img/l_Cypress.afee02f2.svg";